module.exports = __webpack_public_path__ + "img/google.ef7e33ed.png";